<template>
  <v-sheet class="text-center contact">
    <v-row>
      <v-col>
        <h1 class="mt-10 mb-15">Contact Us</h1>

        <h4 class="text-h4">Email us here for general inquiries</h4>
        <p>
          <a href="mailto:hireme@hirenextgeneration.com" class="text-body-1"
            >hireme@hirenextgeneration.com</a
          >
        </p>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {};
</script>

<style lang="scss">
.contact {
  a {
    color: #fc4a46;
  }
}
</style>
